import { CustomerAccount } from '~/types';
import { CartDetails } from '../cart/index';
import { Drawer } from './Drawer.client';
import { useCart } from '@shopify/hydrogen';
import { useEffect, useRef, useState } from 'react';

export function CartDrawer({
  isOpen,
  onClose,
  currency,
  customerAccounts,
}: {
  isOpen: boolean;
  onClose: () => void;
  currency: string;
  customerAccounts?: CustomerAccount[];
}) {
  const { status } = useCart();
  const pending = status === 'fetching' || status === 'creating' || status === 'updating';

  const { progress, visible } = useProgressBar(pending);

  return (
    <Drawer open={isOpen} onClose={onClose} heading="Cart" openFrom="right" backgroundColor="#FAFAFA" progress={progress} visible={visible}>
      <div className="cartDrawerRoot">

        <div
          aria-busy={pending}
          className={`cartDrawerBody ${pending ? 'cartDrawerBody--blocked' : ''}`}
        >
          <div className="grid">
            <CartDetails
              currency={currency}
              layout="drawer"
              onClose={onClose}
              customerAccounts={customerAccounts}
              pending={pending}
            />
          </div>
        </div>
      </div>
    </Drawer>
  );
}

function useProgressBar(active: boolean) {
  const [progress, setProgress] = useState(0);
  const [visible, setVisible] = useState(false);
  const timerRef = useRef<number | null>(null);

  const clearTimer = () => {
    if (timerRef.current) {
      window.clearTimeout(timerRef.current);
      timerRef.current = null;
    }
  };

  useEffect(() => {
    clearTimer();

    if (active) {
      setVisible(true);
      setProgress((p) => (p < 10 ? 10 : p));

      const tick = () => {
        setProgress((p) => {
          if (p >= 95) return p;
          const inc = Math.max((95 - p) * 0.3, 2.5);
          return Math.min(p + inc, 95);
        });
        timerRef.current = window.setTimeout(tick, 120);
      };

      timerRef.current = window.setTimeout(tick, 120);
    } else {
      setProgress(100);
      timerRef.current = window.setTimeout(() => {
        setVisible(false);
        setProgress(0);
        timerRef.current = null;
      }, 350);
    }

    return clearTimer;
  }, [active]);

  return { progress, visible };
}
